import { mapActions, mapGetters } from 'vuex';

export default {
    props: ['name', 'code', 'description', 'price', 'tariffId'],

    data() {
        return {
            check: false
        }
    },

    computed: {
        ...mapGetters(['bundlesCode']),
    },

    methods: {
        ...mapActions(['updateBundles']),

        clickedBundle(code) {
            this.updateBundles({
                code,
                checked: this.check,
            });

            this.$root.$emit('reloadCheckout', true);
        },

        checked() {
            if (this.bundlesCode.length) {
                this.check = this.bundlesCode.indexOf(this.code) !== -1;
            } else {
                this.check = false;
            }
        }
    },

    watch: {
        check: function () {
            this.clickedBundle(this.code)
        }
    },

    mounted() {
        this.checked()
    }
}

